import basex from 'base-x';

const base58CharSet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

export const base58Encode = (input: Uint8Array): string => {
  return basex(base58CharSet).encode(input);
};
